import throttle from 'lodash/throttle'
import {Vector3, Animation, ActionManager, ExecuteCodeAction, Layer, VideoTexture} from 'babylonjs'

export function hotSpotActions (scene, params = {}) {
  // hotspot actions, manual code
  var hotspot1 = scene.meshes[2]
  var hotspot2 = scene.meshes[3]
  var hotspot3 = scene.meshes[5]
  var hotspot4 = scene.meshes[6]
  if (!scene.meshes[2] || (scene.meshes[2] && scene.meshes[2].name.search('hotspot') < 0) || params.slideIndex !== undefined) {
    if (hotspot1 && hotspot2 && hotspot3 && hotspot4) {
      hotspot1.setEnabled(false)
      hotspot2.setEnabled(false)
      hotspot3.setEnabled(false)
      hotspot4.setEnabled(false)
    }
    return
  }

  hotspot1.actionManager = new ActionManager(scene)
  hotspot1.actionManager.registerAction(
    new ExecuteCodeAction(ActionManager.OnPickTrigger,
      (event) => {
        // var pickedMesh = event.meshUnderPointer
        zoomIn(scene)
        hotspot1.setEnabled(false)
        hotspot2.setEnabled(true)
      })
  )

  hotspot2.actionManager = new ActionManager(scene)
  hotspot2.actionManager.registerAction(
    new ExecuteCodeAction(ActionManager.OnPickTrigger,
      (event) => {
        // var pickedMesh = event.meshUnderPointer
        zoomOut(scene)
        hotspot2.setEnabled(false)
        hotspot1.setEnabled(true)
      })
  )

  hotspot3.actionManager = new ActionManager(scene)
  hotspot3.actionManager.registerAction(
    new ExecuteCodeAction(ActionManager.OnPickTrigger,
      (event) => {
        // var pickedMesh = event.meshUnderPointer
        zoomOut(scene)
        hotspot3.setEnabled(false)
        hotspot4.setEnabled(true)
      })
  )

  hotspot4.actionManager = new ActionManager(scene)
  hotspot4.actionManager.registerAction(
    new ExecuteCodeAction(ActionManager.OnPickTrigger,
      (event) => {
        // var pickedMesh = event.meshUnderPointer
        zoomIn(scene)
        hotspot4.setEnabled(false)
        hotspot3.setEnabled(true)
      })
  )
}

export function rotateLeft (mesh) {
  mesh.rotation.y -= 0.1
  // this.mesh.beginAnimation('rotation animation')
  // this.mesh.beginAnimation('position animation')
  // this.mesh.beginAnimation('scaling animation')
}

export function rotateRight (mesh) {
  mesh.rotation.y += 0.1
}

export function zoomIn (scene, newTarget = new Vector3(0, 0, 0), newRadius = 15) {
  if (!(scene.activeCamera.target.x === newTarget.x && scene.activeCamera.target.y === newTarget.y && scene.activeCamera.target.z === newTarget.z)) {
    Animation.CreateAndStartAnimation('targetAnimate', scene.activeCamera, 'target', 20, 20, scene.activeCamera.target, newTarget, 0)
  }
  if (scene.activeCamera.radius !== newRadius) {
    Animation.CreateAndStartAnimation('zoomAnimate', scene.activeCamera, 'radius', 20, 20, scene.activeCamera.radius, newRadius, 0)
  }
}

export function zoomOut (scene, newTarget = new Vector3(0, 0, 0), newRadius = 20) {
  if (!(scene.activeCamera.target.x === newTarget.x && scene.activeCamera.target.y === newTarget.y && scene.activeCamera.target.z === newTarget.z)) {
    Animation.CreateAndStartAnimation('targetAnimate', scene.activeCamera, 'target', 20, 20, scene.activeCamera.target, newTarget, 0)
  }
  if (scene.activeCamera.radius !== newRadius) {
    Animation.CreateAndStartAnimation('zoomAnimate', scene.activeCamera, 'radius', 20, 20, scene.activeCamera.radius, newRadius, 0)
  }
}

export function xrCamera (scene, mesh) {
  if (typeof DeviceOrientationEvent.requestPermission !== 'undefined') {
    DeviceOrientationEvent.requestPermission().then(response => {
      if (response === 'granted') {
        window.addEventListener('deviceorientation', throttle(function (event) {
          handleOrientationEvent(mesh, event.alpha, event.beta, event.gamma)
        }, 100), true)
      }
    }).catch(console.error)
  }

  // Create our video texture for background
  const background = new Layer('back', null, scene)
  VideoTexture.CreateFromWebCam(scene, function (videoTexture) {
    background.texture = videoTexture
    background.texture.level = 0
    background.texture.wAng = Math.PI
    // background.texture.scale(20)
  }, {maxWidth: window.innerWidth, maxHeight: window.innerHeight, facingMode: 'environment'})
}

function handleOrientationEvent (mesh, alpha, beta, gamma) {
  alpha = alpha * Math.PI / 180
  mesh.rotation.y = alpha
}
